import { Card, CategoryBar, Flex, Metric, Text, Tracker } from '@tremor/react'
import React from 'react'

function TimeBasedSentimentCard({ duration, fragment, t, sentimentTranslations, mapSentimentAndColors, ...rest }) {
    return (
        <Card className='flex flex-col h-full justify-between my-1' {...rest}>

            <div>
                <Flex alignItems="start">
                    <p className='font-semibold text-gray-700'>{t('ExpandedMeedingCard.DominantSentimentOverTime')}</p>
                </Flex>
            </div>

            <div>
                <Tracker className="mt-4"
                    data={
                        Object.entries(JSON.parse(fragment.result)).map(([key, value]) => {
                            return { tooltip: (sentimentTranslations(value, t('Language'))), color: mapSentimentAndColors(value) };
                        })
                    }
                />

            </div>
            {fragment.result && <div className='w-full flex justify-center items-center'>
                {(() => {
                    console.error('🚨🚨🚨 TIME BASED SENTIMENT CARD LEGEND RENDERING 🚨🚨🚨');
                    console.error('📊 Fragment result:', fragment.result);
                    
                    let parsedResult;
                    try {
                        parsedResult = JSON.parse(fragment.result);
                        console.error('✅ TIME BASED SENTIMENT - Successfully parsed result:', parsedResult);
                    } catch (error) {
                        console.error('❌ TIME BASED SENTIMENT CARD - JSON parse error:', error);
                        return <div className="text-red-500 italic">Failed to parse time sentiment data</div>;
                    }
                    
                    if (!parsedResult || typeof parsedResult !== 'object') {
                        console.error('❌ TIME BASED SENTIMENT CARD - Invalid parsed result:', parsedResult);
                        return <div className="text-red-500 italic">Invalid time sentiment data structure</div>;
                    }
                    
                    const values = Object.values(parsedResult);
                    console.error('📋 TIME BASED SENTIMENT values:', values);
                    
                    const uniqueValues = [...new Set(values)];
                    console.error('📋 TIME BASED SENTIMENT unique values:', uniqueValues);
                    
                    const categories = uniqueValues.map(value => {
                        const category = sentimentTranslations(value, t('Language'));
                        console.error(`🏷️ TIME BASED SENTIMENT Category for ${value}:`, category);
                        return category;
                    });
                    
                    const colors = uniqueValues.map(value => {
                        const color = mapSentimentAndColors(value) ? mapSentimentAndColors(value) : "black";
                        console.error(`🎨 TIME BASED SENTIMENT Color for ${value}:`, color);
                        return color;
                    });
                    
                    console.error('✅ TIME BASED SENTIMENT CARD - Rendering Legend');
                    
                    // Use custom legend instead of Tremor Legend to prevent Chart.js errors
                    console.error('✅ TIME SENTIMENT CARD - Using CUSTOM LEGEND to bypass Tremor/Chart.js issues');
                    
                    return (
                        <div className="mt-3 max-h-32 overflow-y-auto">
                            <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 px-2">
                                {uniqueValues.map((value, index) => (
                                    <div key={index} className="flex items-center gap-2 flex-shrink-0">
                                        <div 
                                            className={`w-3 h-3 rounded bg-${colors[index] || 'gray-500'}`}
                                        ></div>
                                        <span className="text-sm text-gray-700">
                                            {categories[index]}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    );
                })()}
            </div>}
        </Card >
    )
}

export default TimeBasedSentimentCard
